import '@didi/driver-biz-ui/src/common/stylus/index.styl'
import { Modal } from '@didi/driver-biz-ui'
import Vue from 'vue'

Vue.use(Modal)
